module.exports = __webpack_public_path__ + "static/media/home6.a03d2073.jpg";